import { apiCall } from '../../context/api';

export const handleStripeCheckoutCompletion = async (sessionId, baseURL) => {
  try {
    const session = await apiCall(baseURL, null, 'GET', `/core/webhooks/stripe/session-status?session_id=${sessionId}`);
    return session.status === 'complete';
  } catch (error) {
    console.error('Error checking session status:', error);
    return false;
  }
};
